module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0139.jpg?v=c3fec7c7";